function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.778 8.222a1 1 0 010 1.414L9.636 23.778a1 1 0 01-1.414-1.414L22.364 8.222a1 1 0 011.414 0z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.778 23.778a1 1 0 01-1.414 0L8.222 9.636a1 1 0 011.414-1.414l14.142 14.142a1 1 0 010 1.414z",
  fill: "#fff"
});

function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconClose;